import { cn } from "@/lib/utils";

export function ToolShell({ eyebrow, title, subtitle, step, totalSteps, children }) {
  const progress = totalSteps ? Math.round((step / totalSteps) * 100) : 0;
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-3xl px-4 py-16 lg:px-6 lg:py-24">
        <div className="text-xs font-semibold uppercase tracking-widest text-wafa-primary">{eyebrow}</div>
        <h1 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-wafa-deep sm:text-4xl lg:text-5xl">
          {title}
        </h1>
        {subtitle ? <p className="mt-4 text-sm text-wafa-ink/70 lg:text-base">{subtitle}</p> : null}

        {totalSteps ? (
          <div className="mt-8">
            <div className="flex items-center justify-between text-xs text-wafa-ink/60">
              <span>Step {Math.min(step, totalSteps)} of {totalSteps}</span>
              <span>{progress}%</span>
            </div>
            <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-wafa-deep/10">
              <div className="h-full bg-wafa-primary transition-[width] duration-300 ease-out" style={{ width: `${progress}%` }} />
            </div>
          </div>
        ) : null}

        <div className="mt-10">{children}</div>
      </div>
    </section>
  );
}

export function OptionRow({ label, value, current, onChange, testId }) {
  const active = current === value;
  return (
    <button
      type="button"
      onClick={() => onChange(value)}
      data-testid={testId}
      className={cn(
        "w-full rounded-md border px-4 py-3 text-start text-sm transition-colors",
        active
          ? "border-wafa-primary bg-wafa-primary/5 text-wafa-deep font-semibold"
          : "border-wafa-deep/15 bg-white text-wafa-ink hover:border-wafa-deep/40",
      )}
    >
      {label}
    </button>
  );
}

export function ToolNav({ onBack, onNext, disableNext, nextLabel = "Next" }) {
  return (
    <div className="mt-10 flex items-center justify-between gap-3">
      <button
        type="button"
        onClick={onBack}
        disabled={!onBack}
        className="rounded-md border border-wafa-deep/15 px-4 py-2 text-sm font-medium text-wafa-deep disabled:opacity-40"
        data-testid="tool-back"
      >
        Back
      </button>
      <button
        type="button"
        onClick={onNext}
        disabled={disableNext}
        className="rounded-md bg-wafa-primary px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-wafa-deep disabled:opacity-50"
        data-testid="tool-next"
      >
        {nextLabel}
      </button>
    </div>
  );
}
